const BackToTop = () => {
	const backToTopBtn = document.getElementById("backToTop");
	const scrollThreshold = 500;

	window.addEventListener("scroll", () => {
		if (window.scrollY > scrollThreshold) {
			backToTopBtn.classList.add("show");
		} else {
			backToTopBtn.classList.remove("show");
		}
	});

	backToTopBtn.addEventListener("click", () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});
};

export default BackToTop;
